import gql from 'graphql-tag';

export const REMOVE_STAGE_DOCUMENT = gql`
  mutation RemoveStageDocument($input: RemoveStageDocumentInput!) {
    bpf {
      result: removeStageDocument(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
